export default __webpack_public_path__ + "static/B102-ca65d5ce65ee6e58c6892125dff98d99.jpg";